/**
 * Common tooltip configuration for Chart.js charts
 */
export const chartTooltipConfig = {
  enabled: true,
  backgroundColor: 'rgba(0, 0, 0, 0.8)',
  titleColor: '#fff',
  bodyColor: '#fff',
  borderColor: 'rgba(255, 255, 255, 0.2)',
  borderWidth: 1,
  padding: 12,
  displayColors: true,
  callbacks: {
    label: function(context: any) {
      let label = context.dataset.label || '';
      if (label) {
        label += ': ';
      }
      if (context.parsed.y !== null) {
        label += context.parsed.y.toFixed(2);
      }
      return label;
    }
  }
};

/**
 * Function to get chart tooltip configuration (returns the same config)
 */
export const getChartTooltipConfig = () => chartTooltipConfig;
